import { getItems } from '../index'
import cjViewCart from './cj'
import rtbViewCart from './rtbhouse'
import website from '../../../../../../configs/website.json'
import Cookies from 'js-cookie'

export default (cart, globalData) => {
    const items = getItems(cart)
    const itemIds = items?.map?.(i => i.productId)
    const { webunion } = website
    const { user } = globalData
    const wid = Cookies.get('clientId')
    const cj = webunion.cj?.default

    rtbViewCart({
        ids: itemIds,
        userId: user?.id || wid,
    })

    if (cj) {
        cjViewCart({
            items,
            usdItemTotal: cart.usdItemTotal,
            enterpriseId: cj.enterpriseId,
            tagId: cj.tagId,
            userId: user?.id || wid,
            email: user?.email || cart.shippingDetail?.email || ''
        })
    }

}